import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import StoreLayout from "@/components/StoreLayout";

import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import Product from "@/pages/Product";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import Wishlist from "@/pages/Wishlist";
import StaticPage from "@/pages/StaticPage";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminDiscounts from "@/pages/admin/AdminDiscounts";
import AdminMarketing from "@/pages/admin/AdminMarketing";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminContent from "@/pages/admin/AdminContent";
import AdminImages from "@/pages/admin/AdminImages";
import AdminRingRequests from "@/pages/admin/AdminRingRequests";

const Store = (C) => (
  <StoreLayout><C /></StoreLayout>
);

function App() {
  return (
    <AppProvider>
      <Toaster position="top-center" toastOptions={{ style: { fontFamily: "'Plus Jakarta Sans', sans-serif" } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={Store(Home)} />
          <Route path="/collection/:slug" element={Store(Collection)} />
          <Route path="/product/:slug" element={Store(Product)} />
          <Route path="/checkout" element={Store(Checkout)} />
          <Route path="/confirmation/:orderNumber" element={Store(Confirmation)} />
          <Route path="/account" element={Store(Account)} />
          <Route path="/wishlist" element={Store(Wishlist)} />
          <Route path="/page/:slug" element={Store(StaticPage)} />
          <Route path="/login" element={Store(Auth)} />

          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="discounts" element={<AdminDiscounts />} />
            <Route path="marketing" element={<AdminMarketing />} />
            <Route path="customers" element={<AdminMarketing />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="content" element={<AdminContent />} />
            <Route path="ring-requests" element={<AdminRingRequests />} />
            <Route path="images" element={<AdminImages />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
